module.exports = __webpack_public_path__ + "img/adas_dimensions_2.12259f07.png";